import { render, staticRenderFns } from "./DiscountsTable.vue?vue&type=template&id=429058d0"
import script from "./DiscountsTable.vue?vue&type=script&lang=js"
export * from "./DiscountsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports